module.exports = __webpack_public_path__ + "static/media/clear-button.232ce14c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/clear-button.svg
// module id = 192
// module chunks = 0